import apiCall from 'apps/investment/apiCalls/stock-accounts';
import oldApiCall from 'apps/investment/apiCalls/stockAccount';
import { Button, Dropdown } from 'antd';
import { DetailPage, EditPage } from 'common/ui/AdminCRUD/page';
import { ListPage } from 'common/ui/admin-CRUD/page';
import { Link } from 'react-router-dom';
import { columnsGenerator } from './config';
import ItemDetail from './detail';
import { FilterForm } from './filter-form';
import ItemForm from './form';

export const InvestmentStockAccountListPage = () => (
  <ListPage
    title="All Stock Accounts"
    apiCall={apiCall}
    columnsGenerator={columnsGenerator}
    FilterForm={FilterForm}
  />
);

export const InvestmentStockAccountDetailPage = props => (
  <DetailPage
    title="Stock Account"
    apiCall={apiCall}
    listUrl={`/investment/stock-accounts`}
    ItemDetail={ItemDetail}
    resourceName="data"
    options={{ title: 'View detail', deleteEnabled: false, editEnabled: false }}
    extraActions={id => (
      <Dropdown
        menu={{
          items: [
            {
              key: 'edit',
              label: <Link to={`/investment/stock-accounts/${id}/edit`}>Edit stock account</Link>,
            },
            {
              key: 'add-dividend',
              label: <Link to={`/investment/stock-accounts/${id}/dividends/create`}>Add stock dividend</Link>,
            },
            {
              key: 'view-dividends',
              label: <Link to={`/investment/stock-accounts/${id}/dividends`}>View all dividends</Link>,
            },
          ],
        }}
      >
        <Button>More actions</Button>
      </Dropdown>
    )}
    {...props}
  />
);

export const InvestmentStockAccountEditPage = props => {
  return (
    <EditPage
      title="Stock Account Edit"
      apiCall={oldApiCall}
      listUrl={`/investment/stock-accounts`}
      ItemForm={ItemForm}
      options={{ title: 'Edit Stock Account' }}
      resourceName="data"
      {...props}
    />
  );
};
